<script setup lang="ts">

import { PRICES } from '@presentation/Types/Settings';

</script>

<template>

    <Page>
    
        <ImageAndText 
            animation="zoom"
            src="/ConsumerProposition/carbucks-rewards-logo.png"
            floor-shadow>

            <h2 class="mb-4">What's Included</h2>

            <ul class="mt-3 list-disc text-white/60">
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    <div><span class="text-emerald-500">FREE</span> Vehicle Health Checks</div>
                    <!-- <div class="opacity-60 font-normal">Up to 2 free health checks per year at the dealership</div> -->
                </li>
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    <div>Exclusive Discounts, Offers &amp; Real Cashback at over 1,500 retail partners</div>
                    <!-- <div class="opacity-60 font-normal">Genuine rewards, keeps the customer engaged</div> -->
                </li>
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    <div>Cashback is real money deposited into their account, not points</div>
                    <!-- <div class="opacity-60 font-normal">And you get a clip on all transactions</div> -->
                </li>
                <!-- <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    <div>
                        ${{ PRICES.Subscription.toLocaleString() }} +GST per month, per rooftop
                    </div>
                </li> -->
            </ul>                


        </ImageAndText>

        <!-- <div class="opacity-60 font-normal mt-6">* Maximum of one claim per year of any type</div> -->

        <KeyMessage animation="push-up" class="2xl:-mx-10 2xl:-mt-4">
            <span>
                This is more than a loyalty program - <span class="text-white">it's a retention engine</span>
            </span>
        </KeyMessage>

    </Page>

</template>